export default "__VITE_ASSET__DtI4hE2J__"